export default __webpack_public_path__ + "static/media/grafema_nutrana_10.06a78a40.jpg";